namespace GeniuzPOS.Product {
    export interface PsSetItemDtForm {
        SetItemCode: Serenity.StringEditor;
        PluCode: Serenity.LookupEditor;
        PluDesc: Serenity.StringEditor;
        Qty: Serenity.DecimalEditor;
        Unit: Serenity.LookupEditor;
        NormalUnitPrice: Serenity.DecimalEditor;
        SetUnitPrice: Serenity.DecimalEditor;
        SetPrice: Serenity.DecimalEditor;
    }

    export class PsSetItemDtForm extends Serenity.PrefixedContext {
        static formKey = 'Product.PsSetItemDt';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsSetItemDtForm.init)  {
                PsSetItemDtForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(PsSetItemDtForm, [
                    'SetItemCode', w0,
                    'PluCode', w1,
                    'PluDesc', w0,
                    'Qty', w2,
                    'Unit', w1,
                    'NormalUnitPrice', w2,
                    'SetUnitPrice', w2,
                    'SetPrice', w2
                ]);
            }
        }
    }
}
